import { SimpleJson } from '@dreamstack/simple-components/src/lib/SimpleJson'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import { Fragment } from 'react'
import { ContentfulBlock } from './ContentfulBlock'

export const ContentfulBlocks: FunctionComponent<
  React.PropsWithChildren<{
    // TODO: TYPE
    blocks?: any[]
    customProps?: any
  }>
> = ({ blocks = [], customProps }) => {
  return (
    <>
      {map(blocks, (block, idx) => {
        return (
          <Fragment key={`${block?.id}-${idx}`}>
            <ContentfulBlock
              key={`${block?.id}-${idx}`}
              block={block}
              customProps={customProps}
            />
            {process.env.NODE_ENV === 'development' && (
              <details>
                <summary>JSON for {block?.blockType}</summary>
                <SimpleJson value={block} />
              </details>
            )}
          </Fragment>
        )
      })}
    </>
  )
}
